export default "__VITE_ASSET__C9rz245v__"